module.exports = __webpack_public_path__ + "static/img/about_img_d@1x.74042378.png";